import { Copy } from '@phosphor-icons/react';
import { useToast } from '../../hooks/useToast';

interface CopyForLlmsButtonProps {
  markdown: string;
  /** The heading this copies, for the accessible label. */
  label: string;
}

/** Copies an API reference section's markdown for pasting into an LLM. */
function CopyForLlmsButton({ markdown, label }: CopyForLlmsButtonProps) {
  const { showToast } = useToast();

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(markdown);
      showToast('Copied to clipboard', 'success');
    } catch {
      showToast("Couldn't copy to clipboard", 'error');
    }
  }

  return (
    <button
      type="button"
      className="docs-copy-button docs-copy-llm-button"
      onClick={handleCopy}
      aria-label={`Copy “${label}” for LLMs`}
    >
      <Copy size={12} weight="bold" aria-hidden />
      Copy for LLMs
    </button>
  );
}

export default CopyForLlmsButton;
